module.exports = __webpack_public_path__ + "media/images/favicon-22cb6dcbc446ab2d629598e72ba61797.png";